import { FC, memo, useContext } from 'react'
import { ScreenContext } from 'react-components'

import { Container, CardsContainer, Section, TitleContainer } from './styles'
import { TipSectionTransport } from '../../../transports/region-landing-page-transport'
import { useTranslation } from '../../../hooks/locale'
import TipsSectionCard from './tips-section-card'
import { Subtitle, Title } from '../common/styles'
import { EmblaCarousel } from '../../common/embla-carousel'

interface TipsProps {
    tipsSection: TipSectionTransport
    location: string
}

const TipsSection: FC<TipsProps> = ({ tipsSection, location }) => {
    const { heading, tips } = tipsSection
    const { t } = useTranslation()
    const { isDesktop, isMobile } = useContext(ScreenContext)

    const tipsSectionHeading = heading ? heading : `${t('tipsSectionHeading')} ${location}`
    const subheading = `${t('tipsSectionSubHeading')}${location}`

    return (
        <Section id="tips">
            <Container>
                <TitleContainer>
                    <Title>{tipsSectionHeading}</Title>
                    <Subtitle>{subheading}</Subtitle>
                </TitleContainer>

                <CardsContainer>
                    {isDesktop ? (
                        tips.map((tip, index) => (
                            <TipsSectionCard key={tip.title ?? index} tip={tip} location={location} />
                        ))
                    ) : (
                        <EmblaCarousel
                            slides={tips.map((tip, index) => (
                                <TipsSectionCard key={tip.title ?? index} tip={tip} location={location} />
                            ))}
                            visibleSlides={isMobile ? 1.1 : 1.7}
                            slidesToScroll={1}
                        />
                    )}
                </CardsContainer>
            </Container>
        </Section>
    )
}

export default memo(TipsSection)
